import { useEffect, useContext } from "react"

import Context from "../context"

const useDarkMode = () => {
  const { state, setState } = useContext(Context)

  useEffect(() => {
    // Check localStorage for saved theme preference (only on client-side)
    // Default to dark mode if no preference is saved
    if (typeof window !== "undefined") {
      const savedTheme = localStorage.getItem("darkMode")
      const isDarkMode = savedTheme !== null ? savedTheme === "true" : true

      setState({ ...state, darkMode: isDarkMode })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const toggleDarkMode = () => {
    const newDarkMode = !state.darkMode
    setState({ ...state, darkMode: newDarkMode })
    if (typeof window !== "undefined") {
      localStorage.setItem("darkMode", String(newDarkMode))
    }
  }

  return { darkMode: state.darkMode, toggleDarkMode }
}

export default useDarkMode
